import React, { useState, useEffect } from "react";
import Layout from "../../global/layout";
import ImageSliderDirect from "../ImageSliderDirect";
import ImageSlider from "../ImageSlider";
import ApiClient from "../../../methods/api/apiClient";
import methodModel from "../../../methods/methods";
import loader from "../../../methods/loader";
import { Link, useNavigate } from "react-router-dom";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { RxLightningBolt } from "react-icons/rx";
import StarRatings from "react-star-ratings";
import { useSelector } from "react-redux";
import { IoMdHeart } from "react-icons/io";
import Pagination from "react-js-pagination";
import { IoIosArrowRoundBack } from "react-icons/io";
import { IoIosArrowRoundForward } from "react-icons/io";
import { CiHeart } from "react-icons/ci";

const images1 = [
  "assets/img/front/camper1.svg",
  "assets/img/front/camper2.svg",
];

interface Amenity {
  amenities_image: string;
  amenities_name: string;
  image_alt_name: string;
}

const MyWishlist: React.FC = () => {
  const user = useSelector((state: any) => state.User)
  const [wishlistEmpty, setWishlistEmpty] = useState<boolean>(false);
  const [campervans, setCampervans] = useState<any[]>([]);
  const [totalCampervans, setTotalCampervans] = useState<number>(0);
  const [filter, setFilter] = useState({ page: 1, count: 10, fav_user_id: user?.id || user?._id, isFavourite: true });
  const navigate = useNavigate();

  useEffect(() => {
    getCampervan();
  }, [filter]);

  // It return the all favourite true campervans with current user id
  const getCampervan = (p: any = {}) => {
    loader(true);
    let filters = { ...filter, ...p, status: 'active' }
    ApiClient.get(`all/Campervan`, filters).then((res) => {
      if (res?.success) {
        setCampervans(res?.data);
        setTotalCampervans(res?.total);
        if (res?.total == 0) setWishlistEmpty(true)
      }
    })
      .finally(() => {
        loader(false);
      });
  };

  // Create a common function for all action like view, edit, delete
  const handleAction = (item: any, action: string) => {
    if (action === "view details") {
      navigate(`/campervan/detail/${item?.id || item?._id}/${item?.campervan_type}`);
    }
  };

  // It return the Jucy images with full path
  const showJucyImages = (gallery: { original: string }[], idx: number) => {
    let sliderImages: string[] = [];
    if (gallery) {
      sliderImages = gallery
        .filter((itm) => itm.original.match(/\.(jpg|jpeg|png|svg)$/))
        .slice(0, 5)
        .map((value) => value.original);
    }
    return sliderImages;
  };

  // This function is used for to find the campervan is favourite or not
  const findIsFavourite = (favoriteDetails: any) => {
    let value = false
    if (user?.id || user?._id) {
      favoriteDetails?.filter((item: any) => {
        if (item?.fav_user_id == user?.id) {
          if (item?.isFavourite) value = true
          else value = false
        } else {
          value = false
        }
      })
    } else {
      value = false
    }
    return value
  }

  // It is used to make the campervan favourite or unfavourite
  const handleFavoriteUnFavorite = (id: any) => {
    let token = localStorage.getItem('token')
    if (!token) navigate('/login')
    ApiClient.post(`favourite`, { campervan_id: id }).then(res => {
      if (res.success) {
        getCampervan()
      }
    })
  }

  // This function will handle the pagination and hit the campervan api again with the new page number filter
  const handlePagination = (e: any) => {
    setFilter((prev: any) => ({ ...prev, page: e }))
    getCampervan({ page: e })
  }

  return (
    <Layout>
      <div className="border border-gray-border rounded-2xl p-4 2xl:p-6">
      <h2 className="text-base lg:text-xl 2xl:text-2xl font-semibold text-secondary pb-2.5 2xl:pb-5 border-b border-gray-border mb-4"> Wishlist</h2>
      {wishlistEmpty ? (
        <div>
          
          <div className="max-w-[330px] w-full mx-auto  my-5 2xl:my-10">
            <img
              src="/assets/img/van.svg"
              alt="van-list"
              className="block  w-[280px] h-[200px] 2xl:w-[330px] 2xl:h-[234px] mx-auto"
            />
            <h2 className="text-base lg:text-xl 2xl:text-2xl font-semibold text-secondary mt-5 2xl:mt-10 mb-2 text-center">
              No wishlist yet
            </h2>
            <p className="text-base font-normal text-gray-light text-center mb-3">
              But, it’s easy to fix. Just tap a listing’s heart icon to save it
              to your wishlist.
            </p>
            <Link to="/campervans"
              type="button"
              className="bg-primary h-10 xl:h-12 2xl:h-[54px] w-[180px] shrink-0 rounded-xl text-center text-sm font-normal text-white hover:opacity-80 flex justify-center items-center mx-auto"
            >
              Search RV Rental
            </Link>
          </div>
        </div>
      ) : (
        <div className="">
          <ul className="space-y-4">
            {campervans.map((item, idx) => (
              <>
                {findIsFavourite(item?.favourite_details) ?
                  <li
                    key={idx}
                    className="bg-[#F6F7FB] rounded-2xl border border-primary flex flex-col xl:flex-row gap-2 xl:gap-5">
                    <div className="w-full xl:max-w-[400px] relative p-3 xl:pr-0">
                      {item.campervan_type === "jucy" ? (
                        <ImageSliderDirect
                          images={showJucyImages(item.gallery, idx)}
                          imageHeight={'md:h-[327px] rounded-xl w-full'}
                          id={item?.id || item?._id}
                          data={item}
                        />
                      ) : (
                        <ImageSlider
                          images={item.images.length === 0 ? images1 : item.images}
                          imageCounter
                          id={item?.id || item?._id}
                          imgHeight={327}/>
                      )}
                         <span className="absolute left-7 top-7">
                           <div className="px-3 py-2 rounded-lg bg-secondary text-white flex justify-center items-center text-sm/4 font-normal">$2345/day </div>
                          </span>
                          <span className="size-9 flex items-center justify-center absolute right-5 top-5" role="button" aria-label="add-to-wishlist" onClick={e => handleFavoriteUnFavorite(item?._id)}>
                            <IoMdHeart size={24} className="text-base text-primary" />
                          </span>
                    </div>
                    <div className="flex-1 w-full flex flex-col lg:flex-row">
                      <div className="w-full lg:max-w-[412px] px-4 xl:pr-5 xl:pl-0 lg:py-6">
                        <div className="flex-1 w-full flex flex-col md:flex-row gap-6 items-center justify-center xl:justify-start">
                          <div className="w-full">
                            <h4 className="text-base lg:text-lg font-medium text-secondary mb-2">
                              {item?.campervan_name}
                            </h4>
                            <p
                              className="text-base text-gray-light mb-3.5 line-clamp-2"
                              dangerouslySetInnerHTML={{
                                __html: item?.description,
                              }}>
                            </p>
                            <div className="bg-gray-border rounded-xl py-3 px-5 relative flex justify-between gap-3 items-center">
                              <div>
                                <div className="flex gap-2 mb-1">
                                  <h5 className="text-sm font-normal text-gray-light">
                                    Total Price:
                                    <span className="text-primary font-semibold">
                                      AUD${item?.defaultRate}
                                    </span>
                                  </h5>
                                  {/* <AiOutlineInfoCircle size={20} className="text-secondary" /> */}
                                </div>
                                <p className="text-sm text-gray-light">
                                  Your total savings:
                                  <span className="font-medium text-secondary">AUD$48</span>
                                </p>
                              </div>
                              <span className="bg-[#E13C29] py-1.5 px-3 h-fit rounded-md text-[10px]/[13px] uppercase font-normal text-white">
                                SALE
                              </span>
                            </div>
                            <div className="flex items-center mt-2">
                              <span className="text-sm font-normal text-gray-light mr-1">
                                Ratings:
                              </span>
                              <StarRatings
                                rating={4.5}
                                starSpacing="3px"
                                starRatedColor="#FEB602"
                                starHoverColor="#FEB602"
                                starDimension="16"
                                numberOfStars={5}
                                name="rating"
                              />
                              <span className="ml-5 block text-sm font-normal text-secondary">
                                (4.8)
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="flex justify-center max-sm:flex-wrap gap-2 lg:gap-4 w-full items-center mt-4">
                           <button type="button" 
                            onClick={(e) => handleAction(item, "view details")}
                            className="h-11 text-primary rounded-xl text-sm flex items-center justify-center border border-primary text-center hover:bg-primary hover:text-white transition-all w-full lg:max-w-[187px]">
                            View Details
                          </button>
                          <button
                            type="button"
                            className="w-full lg:max-w-[187px] bg-primary hover:opacity-80 rounded-xl text-sm text-white md:flex items-center justify-center h-11 text-center">
                            Book Now
                          </button>
                        </div>
                      </div>
                      {/* <div className="my-auto hidden lg:flex h-[156px] border-r border-black/20" /> */}
                      <div className="flex-1 w-full flex flex-col gap-5 lg:border-l border-gray-border p-4 xl:px-5 xl:py-6">
                        <span className="whitespace-nowrap shrink-0 w-fit h-10 px-3 py-1.5 rounded-md flex items-center gap-1 bg-[#E6EBFF] text-[10px] font-normal text-secondary max-lg:ml-auto">
                          <RxLightningBolt className="size-3 text-secondary" />
                          Instant Confirmation
                        </span>
                        {item?.highlightedFeatures?.length === 0 ||
                          !item?.highlightedFeatures ? (
                          <>
                            {item?.amenities_name === 0 ||
                              !item?.amenities_name ? (
                              <div className="text-center flex items-center justify-center h-full">
                                <p> No Amenities</p>
                              </div>
                            ) : null}
                          </>
                        ) : null}
                        {/* <div className="grid grid-cols-3 xl:grid-cols-2 2xl:grid-cols-3 gap-6 my-auto"> */}
                        <div className="grid min-[1400px]:grid grid-cols-2 sm:grid-cols-2 xl:grid-cols-2 md:flex flex-col justify-center gap-2.5 min-[1400px]:gap-6 my-auto">
                          {item?.highlightedFeatures?.length === 0 ||
                            !item?.highlightedFeatures ? (
                            <>
                              {item?.amenities_details
                                ?.slice(0, 6)
                                ?.map((itm: Amenity) => {
                                  return (
                                    <div
                                      className="flex flex-col items-center justify-center"
                                      key={idx}
                                    >
                                      <img
                                        src={methodModel.campervanImage(
                                          itm.amenities_image
                                        )}
                                        alt={itm.image_alt_name}
                                        width={30}
                                      />
                                      <p className="text-xs text-gray-light text-center capitalize">
                                        {itm.amenities_name}
                                      </p>
                                    </div>
                                  );
                                })}
                            </>
                          ) : (
                            <>
                              {item?.highlightedFeatures
                                ?.slice(0, 6)
                                ?.map((itm: string) => {
                                  <div className="flex flex-col items-center justify-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                                      <path d="M9.46624 1.91731C8.90794 2.09402 8.67604 2.40667 8.43554 3.31065C8.0748 4.65641 8.02326 4.95547 8.11774 5.27492C8.24658 5.7303 8.67604 6.09053 9.20856 6.19928L9.63802 6.28764V6.64107V6.9877L8.41836 7.02169C7.25024 7.04887 7.16435 7.06247 6.61464 7.26637C5.77291 7.58582 5.15449 8.06839 4.75939 8.70049L4.44159 9.21705L4.46736 11.3308C4.50171 13.635 4.40723 14.7836 4.09803 15.9595C4.06367 16.0682 3.94342 16.1294 3.59986 16.2109C2.99003 16.3537 2.42314 16.7547 2.16547 17.2169C1.73601 18.0121 2.16547 19.1879 3.18758 19.9967C3.72869 20.4181 4.65632 20.8191 5.36922 20.9415C5.68702 20.9891 7.80853 21.0095 12.2663 20.9959L18.6996 20.9755L19.2149 20.8124C20.3487 20.4521 21.1045 19.9084 21.637 19.0588C22.3499 17.9101 21.9892 16.7955 20.761 16.3469C20.529 16.2585 20.2456 16.1837 20.1425 16.1837C20.0137 16.1837 19.9364 16.1362 19.9106 16.0342C19.8849 15.9459 19.8333 15.7216 19.7818 15.5381C19.5671 14.702 19.4898 13.5194 19.5413 11.5687C19.5757 9.9511 19.5671 9.50251 19.464 9.18986C19.1977 8.37425 18.4247 7.66738 17.3768 7.26637C16.8357 7.06247 16.7498 7.04887 15.5903 7.02169L14.362 6.9877V6.63427V6.27404L14.7657 6.19928C15.4357 6.06334 15.9081 5.54679 15.9081 4.94867C15.9081 4.71758 15.4185 2.78729 15.2983 2.52902C15.178 2.28433 14.9719 2.12121 14.6025 1.97168C14.3105 1.85613 14.0786 1.84254 11.9829 1.84934C10.6687 1.84934 9.58649 1.88332 9.46624 1.91731ZM14.3535 2.65136C14.4479 2.72612 14.551 2.90284 14.5768 3.04557C14.6111 3.1883 14.6627 3.39221 14.7056 3.50775C14.886 4.03111 15.0578 4.92828 15.0062 5.0914C14.8688 5.5196 14.9461 5.5128 12 5.5128C9.56072 5.5128 9.31163 5.49921 9.1828 5.39046C8.89935 5.14578 8.91653 4.99625 9.38894 3.23588C9.42329 3.08635 9.45765 2.94362 9.46624 2.92323C9.46624 2.89604 9.54354 2.80089 9.64661 2.69894L9.81839 2.52222H12.0086C14.0528 2.52222 14.1989 2.52902 14.3535 2.65136ZM13.4172 6.63427V7.00809H12H10.5828V6.63427V6.26045H12H13.4172V6.63427ZM9.56931 8.86361C10.746 9.96469 12.5583 11.6299 16.3719 15.1302C18.1499 16.7683 18.1069 16.6935 17.3597 16.877C17.0504 16.945 17.0247 16.9382 16.7928 16.7207C15.7277 15.742 14.0271 14.1855 11.9657 12.2756C9.30304 9.82196 9.07114 9.60446 7.97173 8.60534C7.56804 8.23151 7.23306 7.90527 7.23306 7.87808C7.23306 7.80332 7.68829 7.70136 8.00608 7.69457C8.28953 7.69457 8.37542 7.76254 9.56931 8.86361ZM15.7363 10.59C15.7363 12.1804 15.7191 13.4718 15.702 13.4582C15.6418 13.4039 13.3142 11.2561 12.9191 10.8891C12.6958 10.6852 11.8454 9.90352 11.038 9.15588C10.2221 8.40823 9.55213 7.77613 9.55213 7.74215C9.55213 7.71496 10.9436 7.68777 12.6442 7.68777H15.7363V10.59ZM17.4284 8.09558C17.9609 8.37425 18.2787 8.6801 18.545 9.14908C18.6738 9.39376 18.691 9.64524 18.6652 11.6639C18.648 13.3699 18.6738 14.1175 18.7769 14.804C18.8542 15.2934 18.9315 15.7352 18.9486 15.7895C19.2407 16.5304 18.9401 16.408 17.729 15.3002L16.6811 14.3486V11.0862C16.6811 8.35386 16.6983 7.82371 16.8014 7.82371C16.8615 7.82371 17.1535 7.94605 17.4284 8.09558ZM6.88091 8.65291L7.31895 9.08111V13.0776V17.0741L7.12999 17.0333C6.98398 16.9994 5.11154 16.3061 4.93976 16.2245C4.93117 16.2177 4.95694 16.0954 4.99989 15.9459C5.25756 15.0759 5.35204 13.8592 5.33486 11.6639C5.30909 9.50251 5.31768 9.40736 5.48947 9.1015C5.66984 8.79565 6.23672 8.23151 6.37415 8.23151C6.4085 8.23151 6.64041 8.42182 6.88091 8.65291ZM9.74109 11.3037C10.5227 12.0241 12.1976 13.5602 13.4516 14.7156C15.5559 16.6595 15.7363 16.843 15.7363 17.0741V17.3256L15.1179 17.4411C14.3363 17.5839 12.6786 17.7402 12 17.7402C11.3215 17.7402 9.66379 17.5839 8.89077 17.4411L8.26376 17.3256V13.6621C8.26376 11.6503 8.28094 9.99868 8.29811 9.99868C8.3067 9.99868 8.95948 10.59 9.74109 11.3037ZM5.44652 17.2101C9.39752 18.7937 14.3277 18.8073 18.3818 17.2644C18.8713 17.0741 19.3695 16.8974 19.4812 16.8634C19.8333 16.7547 20.3916 16.9042 20.7695 17.2101C21.0959 17.4683 21.1045 17.5023 21.1045 17.9373C21.0959 18.5014 20.8211 18.9772 20.1941 19.487C19.7217 19.8676 19.2235 20.0919 18.545 20.2346C17.8922 20.3706 6.10788 20.3706 5.45511 20.2346C4.77657 20.0919 4.2784 19.8676 3.80599 19.487C3.17899 18.9772 2.90414 18.5014 2.89555 17.9373C2.89555 17.4955 2.90414 17.4751 3.23052 17.2101C3.57409 16.9314 4.08944 16.7751 4.44159 16.843C4.53607 16.8634 4.9913 17.0265 5.44652 17.2101Z" fill="#2B2B2B" />
                                    </svg>
                                    <p className="text-xs text-gray-light text-center capitalize">{itm}</p>
                                  </div>
                                })}
                            </>
                          )}
                        </div>
                      </div>
                        <button type="button" onClick={(e) => handleAction(item, "view details")} className="h-11 text-primary rounded-xl text-lg flex items-center justify-center border border-primary text-center hover:bg-primary hover:text-white transition-all w-full hidden">View Details</button>
                    </div>
                  </li>
                  : null}
              </>
            ))}
          </ul>
          {totalCampervans != 0 ?
            <div className="mt-6 2xl:mt-12">
              <Pagination
                prevPageText={<IoIosArrowRoundBack className="text-xl md:text-2xl font-extralight absolute md:left-5 left-0 top-1.5 md:top-2" />}
                nextPageText={<IoIosArrowRoundForward className="text-xl md:text-2xl font-extralight absolute md:right-6 right-0 top-1.5 md:top-2" />}
                activePage={filter?.page}
                itemsCountPerPage={filter?.count}
                totalItemsCount={totalCampervans}
                pageRangeDisplayed={7}
                onChange={handlePagination}
                hideFirstLastPages={true}
              />
            </div>
          : null}
        </div>
      )}
</div>
    </Layout>
  );
};

export default MyWishlist;
